import { Box, Snackbar, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import strings from "global/constants/StringConstants";
import { CustomIcon } from "..";

interface CustomProps {
  showNotification: boolean;
  verticalPosition: "top" | "bottom";
  horizontalPosition: "left" | "right";
  variant: string;
  title: string;
  message: string;
  icon: JSX.Element;
  handleClose: any;
}

const getStyles = (variant: string) => {
  switch (variant) {
    case strings.info:
      return {
        backgroundColor: "#FFFFFF",
        color: "#000000 !important",
        border: "1px solid #125DDB",
      };
    case strings.success:
      return {
        backgroundColor: "#E7F9ED",
        color: "#000000 !important",
        border: "1px solid #28A745",
      };
    case strings.warning:
      return {
        backgroundColor: "#FFF8E8", //#FFF8E8  add 000 (zeros behiond color and make background transperant)
        color: "#000000 !important",
        border: "1px solid #FFC530",
      };
    case strings.error:
      return {
        backgroundColor: "#FBECE7",
        color: "#000000 !important",
        border: "1px solid #FF3A55",
      };
    default:
      break;
  }
};

const getNotificationTitle = (type: string) => {
  switch (type) {
    case strings.success:
      return "Success!";
    case strings.warning:
      return "Oops!";
    case strings.error:
      return "Oops!";
    case strings.info:
      return "Info";
  }
};

const CustomNotification = (props: CustomProps) => {
  const styles = getStyles(props.variant);
  const customClassesStyle = {
    notificationBlock: {
      ...styles,
      padding: "16px",
      borderRadius: "10px",
      maxWidth: "350px",
    },
  } as const;

  const customClasses = customClassesStyle;
  return (
    <Snackbar
      open={props.showNotification}
      anchorOrigin={{
        vertical: props.verticalPosition,
        horizontal: props.horizontalPosition,
      }}
      autoHideDuration={strings.autoHideDuration}
      onClose={props.handleClose}
    >
      <Stack
        sx={customClasses.notificationBlock}
        gap={1}
        alignItems="flex-start"
        direction="column"
      >
        <Box>{props.icon}</Box>
        <Stack spacing={1}>
          <Typography variant="h6">
            {getNotificationTitle(props.variant)}
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
            {props.message}
          </Typography>
        </Stack>
        <Box sx={{ cursor: "pointer" }} onClick={props.handleClose}>
          <CustomIcon
            icon={<Close fontSize="small" htmlColor={styles?.color} />}
          />
        </Box>
      </Stack>
    </Snackbar>
  );
};

export default CustomNotification;
